/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Achievement_Tonne_Session_HintInputs */

const en_us2_achievement_tonne_session_hint = /** @type {(inputs: Achievement_Tonne_Session_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 t in a single workout`)
};

const pt_br2_achievement_tonne_session_hint = /** @type {(inputs: Achievement_Tonne_Session_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 t num único treino`)
};

const es_419_achievement_tonne_session_hint = /** @type {(inputs: Achievement_Tonne_Session_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 t en un solo entrenamiento`)
};

const pt_pt2_achievement_tonne_session_hint = /** @type {(inputs: Achievement_Tonne_Session_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 t num único treino`)
};

const fr_fr2_achievement_tonne_session_hint = /** @type {(inputs: Achievement_Tonne_Session_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 t en une seule séance`)
};

const de_de2_achievement_tonne_session_hint = /** @type {(inputs: Achievement_Tonne_Session_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 t in einem einzigen Training`)
};

const it_it2_achievement_tonne_session_hint = /** @type {(inputs: Achievement_Tonne_Session_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 t in un solo allenamento`)
};

/**
* | output |
* | --- |
* | "10 t in a single workout" |
*
* @param {Achievement_Tonne_Session_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const achievement_tonne_session_hint = /** @type {((inputs?: Achievement_Tonne_Session_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Achievement_Tonne_Session_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_achievement_tonne_session_hint(inputs)
	if (locale === "es-419") return es_419_achievement_tonne_session_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_achievement_tonne_session_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_achievement_tonne_session_hint(inputs)
	if (locale === "de-DE") return de_de2_achievement_tonne_session_hint(inputs)
	if (locale === "it-IT") return it_it2_achievement_tonne_session_hint(inputs)
	return en_us2_achievement_tonne_session_hint(inputs)
});
export { achievement_tonne_session_hint as "achievement.tonne_session_hint" }